import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { SellionsFormsModule } from '../../../../submodules/sellions_forms/projects/forms/src/public-api';
import { TaskAddPage } from './task-add';

@NgModule({
  declarations: [TaskAddPage],
  imports: [SellionsFormsModule, IonicPageModule.forChild(TaskAddPage)],
})
export class TaskAddModule {}



// WEBPACK FOOTER //
// ./src/modules/tasks/pages/task-add/task-add.module.ts